import moment from 'moment';

import CircleCompletedSvg from 'app/assets/training-plans/training-plan-tracker/circle-completed.svg';
import CircleTodaySvg from 'app/assets/training-plans/training-plan-tracker/circle-today.svg';
import CircleDottedSvg from 'app/assets/training-plans/training-plan-tracker/circle-dotted.svg';
import CircleYellowSvg from 'app/assets/training-plans/training-plan-tracker/circle-yellow.svg';

import MoonIconIncomingSvg from 'app/assets/training-plans/training-plan-tracker/moon-grey.svg';
import MoonIconTodaySvg from 'app/assets/training-plans/training-plan-tracker/moon-yellow.svg';
import MoonIconCompletedSvg from 'app/assets/training-plans/training-plan-tracker/moon-empty.svg';

export enum WorkoutDayStatus {
  COMPLETED = 'completed',
  TODAY = 'today',
  UPCOMING = 'upcoming',
  REST = 'rest',
}

export enum WeekStatus {
  COMPLETED = 'completed',
  CURRENT = 'current',
  UPCOMING = 'upcoming',
}

export type TimeStatus = WorkoutDayStatus.COMPLETED | WorkoutDayStatus.TODAY | WorkoutDayStatus.UPCOMING;

export type GetWorkoutDayStatusArgs = {
  scheduledDate: Date;
  isCompleted: boolean;
  lessonId: string | null;
  today?: Date;
};

export const getWorkoutDayStatus = ({
  scheduledDate,
  isCompleted,
  lessonId,
  today = new Date(),
}: GetWorkoutDayStatusArgs): WorkoutDayStatus => {
  if (lessonId === null) {
    return WorkoutDayStatus.REST;
  }

  if (isCompleted) {
    return WorkoutDayStatus.COMPLETED;
  }

  const scheduled = moment(scheduledDate).startOf('day');
  const todayNormalized = moment(today).startOf('day');

  if (scheduled.isSame(todayNormalized)) {
    return WorkoutDayStatus.TODAY;
  }

  if (scheduled.isBefore(todayNormalized)) {
    return WorkoutDayStatus.COMPLETED;
  }

  return WorkoutDayStatus.UPCOMING;
};

export const getCircleSvg = (status: WorkoutDayStatus): string => {
  switch (status) {
    case WorkoutDayStatus.COMPLETED:
      return CircleCompletedSvg;
    case WorkoutDayStatus.TODAY:
      return CircleTodaySvg;
    case WorkoutDayStatus.REST:
      return CircleDottedSvg;
    default:
      return CircleDottedSvg;
  }
};

export const getMoonIconSvg = (timeStatus: TimeStatus): string => {
  switch (timeStatus) {
    case WorkoutDayStatus.COMPLETED:
      return MoonIconCompletedSvg;
    case WorkoutDayStatus.TODAY:
      return MoonIconTodaySvg;
    default:
      return MoonIconIncomingSvg;
  }
};

export const getRestDayCircleSvg = (timeStatus: TimeStatus): string => {
  switch (timeStatus) {
    case WorkoutDayStatus.COMPLETED:
      return CircleYellowSvg;
    case WorkoutDayStatus.TODAY:
      return CircleTodaySvg;
    default:
      return CircleDottedSvg;
  }
};

export const getWeekStatus = (weekNumber: number, currentWeekNumber: number | undefined): WeekStatus => {
  if (!currentWeekNumber) {
    return WeekStatus.UPCOMING;
  }
  if (weekNumber < currentWeekNumber) {
    return WeekStatus.COMPLETED;
  }
  if (weekNumber === currentWeekNumber) {
    return WeekStatus.CURRENT;
  }
  return WeekStatus.UPCOMING;
};
